import React, { useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser } from '@coreui/icons'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { register } from '../../../Redux/Actions/authAction'

const Register = () => {
  const [userName, setUserName] = useState('')
  const [emailId, setEmailId] = useState('')
  const [password, setPassword] = useState('')
  const [rePassword, setRePassword] = useState('')
  const [visible, setVisible] = useState(false)
  const [errorData, setErrorData] = useState({})

  // const context = useContext(GlobalContext)
  const history = useHistory()
  const dispatch = useDispatch()

  console.log('errorData', errorData)

  const validateInfo = () => {
    let isFormValid = true
    let temp = {
      userName: '',
      emailId: '',
      password: '',
      rePassword: '',
    }

    if (userName.trim().length === 0) {
      isFormValid = false
      temp.userName = 'User Name Cannot be Empty!'
    }
    if (emailId.trim().length === 0) {
      isFormValid = false
      temp.emailId = 'Email Cannot be Empty!'
    }

    if (!emailId.includes('@') && emailId.trim().length !== 0) {
      isFormValid = false
      temp.emailId = 'Invalid Email Address!'
    }

    if (password !== rePassword) {
      isFormValid = false
      temp.rePassword = "Passwords Don't Match!"
    }
    if (password.trim().length === 0) {
      isFormValid = false
      temp.password = 'Password Cannot be Empty!'
    }
    if (rePassword.trim().length === 0) {
      isFormValid = false
      temp.rePassword = 'Password Cannot be Empty!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleRegister = async () => {
    if (validateInfo()) {
      let data = { email_id: emailId, password: password }
      const res = await dispatch(register(data))
      // console.log(res)
      if (res?.isRegistered) {
        setVisible(true)
        setTimeout(() => {
          history.push({ pathname: '/login', state: '/login' })
        }, 3000)
      }
    }
  }

  const onValueChange = (event, fn) => {
    fn(event.target.value)
  }
  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={9} lg={7} xl={6}>
            <CCard className="mx-4">
              <CCardBody className="p-4">
                <CForm>
                  <h1>Register</h1>
                  <p className="text-medium-emphasis">Create your account</p>
                  <CInputGroup className="mb-3">
                    <CInputGroupText>
                      <CIcon icon={cilUser} />
                    </CInputGroupText>
                    <CFormInput
                      placeholder="Username"
                      autoComplete="username"
                      value={userName}
                      onChange={(e) => onValueChange(e, setUserName)}
                    />
                  </CInputGroup>
                  <CInputGroup className="mb-3">
                    <CInputGroupText>@</CInputGroupText>
                    <CFormInput
                      placeholder="Email"
                      autoComplete="email"
                      value={emailId}
                      onChange={(e) => onValueChange(e, setEmailId)}
                    />
                  </CInputGroup>
                  <CInputGroup className="mb-3">
                    <CInputGroupText>
                      <CIcon icon={cilLockLocked} />
                    </CInputGroupText>
                    <CFormInput
                      type="password"
                      placeholder="Password"
                      autoComplete="new-password"
                      value={password}
                      onChange={(e) => onValueChange(e, setPassword)}
                    />
                  </CInputGroup>
                  <CInputGroup className="mb-4">
                    <CInputGroupText>
                      <CIcon icon={cilLockLocked} />
                    </CInputGroupText>
                    <CFormInput
                      type="password"
                      placeholder="Repeat password"
                      autoComplete="new-password"
                      value={rePassword}
                      onChange={(e) => onValueChange(e, setRePassword)}
                    />
                  </CInputGroup>
                  <div className="d-grid">
                    <CButton color="success" onClick={handleRegister}>
                      Create Account
                    </CButton>
                  </div>
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
      <CModal visible={visible} onDismiss={() => setVisible(false)}>
        <CModalHeader onDismiss={() => setVisible(false)}>
          <CModalTitle>Modal title</CModalTitle>
        </CModalHeader>
        <CModalBody>Thanks for signing up! You can login now</CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setVisible(false)}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default Register
